import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prodSizeFilter'
})
export class ProdSizeFilter implements PipeTransform {

  transform(value: any, args?: any): any {
    const newValue = value.replace("%WIDTHx%HEIGHT", args + "x" + args);
    return newValue;
  }
}

